<div class="page" style="height: 100%!important;">
  <iframe *ngIf="url" [src]="url" style="border:none;" height="100%" width="100%" frameborder="0" allowfullscreen="true"
          mozallowfullscreen="true" webkitallowfullscreen="true"></iframe>
</div>

